<template>
  <div class="container">
    <div class="title">{{ $t('asset').Transfer }}</div>
    <div class="info">
      <!-- 账户选择 -->
      <!-- 账户选择 -->
      <div class="accoountInfo">
        <div class="left">
          <!-- 从 钱包 现货账户-->
          <PopoverSelect :items="actions_from" :onSelect="onSelect_from" v-if="isFrom">
            <template #reference>
              <div class="item">{{ $t('asset').From }}<span>{{ activeFrom == 1 ? $t('asset').UsdtContractaccount :
                activeFrom == 2 ? $t('asset').FiatContractaccount : activeFrom == 3 ? $t('asset').Spotaccount :
                  activeFrom == 4 ? $t('asset').Walletaccount : activeFrom == 5 ? $t('finance').financeAccount : '' }}
                  <van-icon name="arrow-down" size="13" color="var(--ntext_color)" /></span>
              </div>
            </template>
          </PopoverSelect>
          <!-- 从 其他账户 -->
          <PopoverSelect :items="actions_to_filtered" :onSelect="onSelect_from" v-else>
            <template #reference>
              <div class="item">{{ $t('asset').From }}<span>{{ activeFrom == 1
                ? $t('asset').UsdtContractaccount : activeFrom == 2 ? $t('asset').FiatContractaccount : activeFrom ==
                  3 ? $t('asset').Spotaccount : activeFrom == 4 ? $t('asset').Walletaccount : activeFrom == 5 ?
                    $t('finance').financeAccount : '' }}
                  <van-icon name="arrow-down" size="13" color="var(--ntext_color)" /></span>
              </div>
            </template>
          </PopoverSelect>
          <div class="line"></div>
          <!-- 到 钱包 现货账户-->
          <PopoverSelect :items="actions_from" :onSelect="onSelect_to" v-if="!isFrom">
            <template #reference>
              <div class="item">{{ $t('asset').To }}<span>{{
                activeTo == 1 ? $t('asset').UsdtContractaccount : activeTo == 2 ? $t('asset').FiatContractaccount :
                  activeTo == 3 ? $t('asset').Spotaccount : activeTo == 4 ? $t('asset').Walletaccount : activeTo == 5 ?
                    $t('finance').financeAccount : '' }}
                  <van-icon name="arrow-down" size="13" color="var(--ntext_color)" /></span>
              </div>
            </template>
          </PopoverSelect>
          <!-- 到 其他账户 -->
          <PopoverSelect :items="actions_to_filtered" :onSelect="onSelect_to" v-else>
            <template #reference>
              <div class="item">{{ $t('asset').To }}<span>{{
                activeTo == 1 ? $t('asset').UsdtContractaccount : activeTo == 2 ? $t('asset').FiatContractaccount :
                  activeTo == 3 ? $t('asset').Spotaccount : activeTo == 4 ? $t('asset').Walletaccount : activeTo == 5 ?
                    $t('finance').financeAccount : '' }}
                  <van-icon name="arrow-down" size="13" color="var(--ntext_color)" /></span>
              </div>
            </template>
          </PopoverSelect>
        </div>
        <svg-icon class-name="svgs" icon-class="transfer" @click="changeAccount" />
      </div>
      <!-- 选择币种 -->
      <div class="tit">{{ $t('asset').Currency }}</div>
      <PopoverSelect :items="currencyArr" :onSelect="onSelect" v-if="isCurrencySel">
        <template #reference>
          <div class="selInfo">
            <div class="left">
              <img class="img" :src="require(`@/assets/img/${currency}.png`)" />
              <div class="name">{{ currency }}</div>
            </div>
            <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
          </div>
        </template>
      </PopoverSelect>
      <div class="selInfo" v-else>
        <div class="left">
          <img class="img" :src="require(`@/assets/img/${currency}.png`)" />
          <div class="name">{{ currency }}</div>
        </div>
      </div>
      <!-- 数量 -->
      <div class="tit">{{ $t('asset').quantity }}</div>
      <div class="numInfo">
        <van-field v-model="Amount" type="number" :placeholder="$t('recharge').amountMsg" @input="onInputNum">
          <template #right-icon>
            <span style="color: var(--ntext_color)">{{ currency }}</span>
          </template>
        </van-field>
      </div>
      <!-- 选择百分比 -->
      <div class="sliderPrecent">
        <!-- <van-slider v-model="activePrecent" @change="handlePrecent" bar-height="7" button-size="12"
          active-color="var(--text_color)" inactive-color="var(--info_color)">
        </van-slider>
        <div class="slable"><span>0%</span><span>25%</span><span>50%</span><span>75%</span><span>100%</span></div> -->
        <vue-slider v-model="activePrecent" @drag-start="onDragStart" @drag-end="onDragEnd" @change="handlePrecent" :min="0" :max="100" :interval="1" :marks="{ 0: '0%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' }" :dot-size="15" :tooltip="'hover'"
          :rail-style="{ backgroundColor: 'var(--info_color)', height: '5px' }" :process-style="{ backgroundColor: 'var(--text_color)' }" :dot-style="{ backgroundColor: 'var(--background_color)', border: '2px solid var(--text_color)' }"
          :tooltip-style="{ backgroundColor: 'var(--info_color)', color: 'var(--text_color)', padding: '4px 8px', borderRadius: '4px' }" />
      </div>
      <div class="lables">{{ $t('asset').availablebalance }}<span>{{ AssetBalance }} {{ currency }}</span></div>
      <!-- 按钮 -->
      <van-button block :loading="btnloading" @click="handleSub">{{ $t('public').confirm }}</van-button>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import PopoverSelect from '@/components/popoverSelect.vue'
import { EventBus } from '@/utils/event-bus'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    PopoverSelect,
    VueSlider
  },
  data() {
    return {
      btnloading: false,
      baseUrl: window.baseURL,
      isCurrencySel: false,//只有现货账户需要选择
      showcurrency: false,
      currency: 'USDT',
      currencyArr: [],
      activeFrom: 4,
      activeTo: 1,
      isFrom: true,
      dragging: false,
      activePrecent: 0,//余额百分比
      Amount: '',
      AssetBalance: 0
    }
  },
  computed: {
    actions_from() {
      return [
        { text: this.$t('asset').Spotaccount, val: 3 },
        { text: this.$t('asset').Walletaccount, val: 4 },
      ]
    },
    actions_to() {
      return [
        { text: this.$t('asset').UsdtContractaccount, val: 1 },
        // { text: this.$t('asset').FiatContractaccount, val: 2 },
        { text: this.$t('asset').Spotaccount, val: 3 },
        { text: this.$t('asset').Walletaccount, val: 4 },
        { text: this.$t('finance').financeAccount, val: 5 },
      ]
    },
    actions_to_filtered() {
      if (this.isFrom)
        return this.actions_to.filter(item => item.val !== this.activeFrom);
      else
        return this.actions_to.filter(item => item.val !== this.activeTo);
    }
  },
  async mounted() {
    window.scrollTo(0, 0);
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    if (this.$route.query.t) {
      this.activeTo = this.$route.query.t
    }
    if (this.$route.query.f) {
      this.activeFrom = this.$route.query.f
    }
    this.getAssetBalance()
    this.getCurrencyNetworkSetting()
  },
  methods: {
    onDragStart() {
      this.dragging = true
    },
    onDragEnd() {
      this.dragging = false
    },
    //获取系统币种
    async getCurrencyNetworkSetting() {
      const res = await systemApi.getCurrencyNetworkSetting()
      this.currencyArr = res.currencyArr.split(',').map(item => ({ text: item }))
    },
    // 选择From账户
    async onSelect_from(action) {
      if (this.activeTo == action.val) return
      this.activeFrom = action.val
      this.onSelectCoin()
      this.getAssetBalance()
    },
    // 选择To账户
    async onSelect_to(action) {
      if (this.activeFrom == action.val) return
      this.activeTo = action.val
      this.onSelectCoin()
    },
    // 切换账户
    async changeAccount() {
      this.isFrom = !this.isFrom
      const temp = this.activeTo
      this.activeTo = this.activeFrom
      this.activeFrom = temp
      this.Amount = ''
      this.onInputNum()
      this.onSelectCoin()
      this.getAssetBalance()
    },
    //选择币种事件
    onSelectCoin() {
      this.showPopover = false
      if ((this.activeFrom == 3 && this.activeTo == 4) || (this.activeFrom == 4 && this.activeTo == 3)) {
        this.isCurrencySel = true
      } else {
        this.isCurrencySel = false
        this.currency = 'USDT'
      }
    },
    //选择币种
    async onSelect(action) {
      this.currency = action.text
      this.getAssetBalance()
    },
    //选择百分比滑块
    handlePrecent(val) {
      if (!this.dragging) {
        // 不是拖动时（即点击），自动调整到最近的 marks 值
        const snapPoints = [0, 25, 50, 75, 100]
        const closest = snapPoints.reduce((a, b) =>
          Math.abs(b - val) < Math.abs(a - val) ? b : a
        )
        this.activePrecent = closest
      }
      this.Amount = ((this.activePrecent / 100) * this.AssetBalance).toFixed(6).replace(/\.?0+$/, '')
    },
    //输入数量事件
    onInputNum() {
      this.activePrecent = Number(this.Amount / this.AssetBalance * 100)
      if (this.activePrecent > 100) this.activePrecent = 100
      if (this.Amount > this.AssetBalance)
        this.$toast(this.$t('asset').Insufficientavailablebalance)
    },
    // 获取资产余额
    async getAssetBalance() {
      var currency = this.currency
      if (this.activeFrom == 2) currency = 'USD'
      const res = await userApi.getAssetBalance({ assetType: this.activeFrom, currency: currency })
      this.AssetBalance = res.assetWallet.amount
    },
    // 提交
    async handleSub() {
      if (!this.Amount) {
        this.$toast({ message: this.$t('recharge').amountMsg })
        return false
      }
      if (this.Amount > this.AssetBalance) {
        this.$toast(this.$t('asset').Insufficientavailablebalance)
        return false
      }
      const form = {
        fromAssetType: this.activeFrom,
        toAssetType: this.activeTo,
        currency: this.currency,
        amount: this.Amount,
      }
      this.btnloading = true
      await userApi.transfer(form)
      this.btnloading = false
      this.$toast(this.$t('asset').Transfersuccessful)
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .info {
    margin: 0 auto;
    max-width: 480px;

    .accoountInfo {
      margin: 30px 0;
      padding: 5px 20px;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        width: 100%;

        .item {
          display: flex;
          align-items: center;
          color: var(--ntext_color);
          font-size: 15px;
          padding: 15px 0;

          span {
            margin-left: 15px;
            font-weight: bold;
            font-size: 18px;
            color: var(--text_color);

            &:hover {
              opacity: 0.8;
            }
          }
        }

        .line {
          border-bottom: 1px dashed var(--info_color);
        }
      }

      .svgs {
        margin-left: 15px;
        width: 35px;
        height: 35px;
        color: var(--text_color);

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .tit {
      margin-top: 10px;
      font-size: 15px;
      color: var(--text_color);
    }

    .ric {
      transform: rotate(90deg);
    }

    .selInfo {
      margin: 10px 0 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      height: 50px;
      padding: 15px;

      &:hover {
        border: 1px solid var(--text_color);
      }

      .left {
        display: flex;
        align-items: center;

        .img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }

        .name {
          margin-left: 10px;
          font-size: 18px;
          font-weight: bold;
          color: var(--text_color);
        }
      }
    }

    .numInfo {
      margin-top: 10px;
    }

    .sliderPrecent {
      margin: 20px 10px;

      .slable {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        color: var(--ntext_color);
      }
    }

    .lables {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: right;
      font-size: 15px;
      color: var(--ntext_color);

      span {
        margin-left: 10px;
        color: var(--text_color);
        font-weight: bold;
      }
    }

    .van-button {
      margin: 50px 0;
      background: var(--text_color);
      height: 50px;
      border-radius: 25px;
      border: 0;
      font-size: 16px;
      color: var(--background_color);

      &:hover {
        opacity: 0.8;
      }
    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

.van-cell {
  background: var(--background_color);
  border: 1px solid var(--info_color);
  height: 50px;
  padding: 10px;
  border-radius: 10px;
  font-size: 20px;
  font-weight: bold;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}

::v-deep .vue-slider-dot-tooltip-inner-top::after {
  border-top-color: var(--info_color) !important;
}

::v-deep .vue-slider-mark {
  background: var(--background_color);
  width: 10px !important;
  height: 10px !important;
  border: 2px solid var(--info_color);
  border-radius: 50%;
}

::v-deep .vue-slider-mark-active {
  border: 2px solid var(--text_color);
}

::v-deep .vue-slider-mark-label {
  color: var(--ntext_color);
  font-size: 11px;
}
</style>
